import React, { useState, useEffect } from "react";
import { ReactComponent as Cancel } from "../../../Assets/Image/svg/cancel.svg";
import { useForm } from "react-hook-form";
import FinalCourseSurvey from "./FinalCourseSurvey";
import LoginForm from "./LoginForm";
import RefereeSurvey from "./RefereeSurvey";

function SurveyModal({
    close,
    surveyQuestions,
    surveyType,
    setSurveyType,
    getSurveysQuestions,
}) {
    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
    } = useForm();
    const onSubmit = (data) => console.log("data", data);

    return (
        <div className="AddnewsupportTicket relative">
            <button
                onClick={() => close(false)}
                className="AddnewsupportTicket-cancel absolute"
            >
                <div>
                    <Cancel />
                </div>
            </button>
            <h3 className=" text-center text-[#77498F] text-[16px] mb-16">
                ثبت نظر سنجی جدید
            </h3>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className=" flex items-center justify-between">
                    <p className=" text-[#212121E5] text-[1.8rem] font-normal leading-[3.2rem]">
                        نظر سنجی:
                    </p>
                    <div className=" flex flex-row items-center justify-between w-5/6">
                        <div className=" flex items-center justify-start">
                            <label
                                htmlFor="weak"
                                className=" text-[#212121E5] text-[1.4rem] leading-[2.4rem] font-normal flex flex-row items-center"
                            >
                                <input
                                    {...register("course", { required: true })}
                                    type="radio"
                                    name="course"
                                    value="weak"
                                    className="form-check-input PriceForm radio-lg ml-[0.8rem]"
                                    id="weak"
                                    checked={
                                        surveyType === "EndCourse"
                                            ? true
                                            : false
                                    }
                                    onClick={() => setSurveyType("EndCourse")}
                                />
                                نظر سنجی پایان دوره
                            </label>
                        </div>
                        <div className=" flex items-center justify-start">
                            <label
                                htmlFor="medium"
                                className=" text-[#212121E5] text-[1.4rem] leading-[2.4rem] font-normal flex flex-row items-center"
                            >
                                <input
                                    {...register("course", { required: true })}
                                    type="radio"
                                    name="course"
                                    value="medium"
                                    className="form-check-input PriceForm radio-lg ml-[0.8rem]"
                                    id="medium"
                                    checked={
                                        surveyType === "RegisterForm"
                                            ? true
                                            : false
                                    }
                                    onClick={() =>
                                        setSurveyType("RegisterForm")
                                    }
                                />
                                سوالات فرم ثبت نام
                            </label>
                        </div>
                        <div className=" flex items-center justify-start">
                            <label
                                htmlFor="strong"
                                className=" text-[#212121E5] text-[1.4rem] leading-[2.4rem] font-normal flex flex-row items-center"
                            >
                                <input
                                    {...register("course", { required: true })}
                                    type="radio"
                                    name="course"
                                    value="strong"
                                    className="form-check-input PriceForm radio-lg ml-[0.8rem]"
                                    id="strong"
                                    checked={
                                        surveyType === "Referee" ? true : false
                                    }
                                    onClick={() => setSurveyType("Referee")}
                                />
                                سوالات داوری
                            </label>
                        </div>
                    </div>
                </div>
                {surveyType === "EndCourse" && (
                    <div>
                        <FinalCourseSurvey
                            list={surveyQuestions?.results}
                            surveyType={surveyType}
                            getSurveysQuestions={getSurveysQuestions}
                        />
                    </div>
                )}
                {surveyType === "RegisterForm" && (
                    <div>
                        <LoginForm
                            list={surveyQuestions?.results}
                            surveyType={surveyType}
                            getSurveysQuestions={getSurveysQuestions}
                        />
                    </div>
                )}
                {surveyType === "Referee" && (
                    <div>
                        <RefereeSurvey
                            list={surveyQuestions?.results}
                            surveyType={surveyType}
                            getSurveysQuestions={getSurveysQuestions}
                        />
                    </div>
                )}
            </form>
        </div>
    );
}

export default SurveyModal;
